"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
function useNumberOfPlayers() {
    return (0, react_redux_1.useSelector)(function (state) { return state.players.length; });
}
exports.default = useNumberOfPlayers;
